import { render } from "./App.vue?vue&type=template&id=ccaae5d2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\maxcs.tan\\source\\repos\\IES-NameCard-NetCore\\DigitalNamecard\\wwwroot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__